import React from 'react';

const Html = ({ html }) => (
    <div dangerouslySetInnerHTML={{ __html: html || '' }} />
);

export default Html;
